import { useAppSelector } from '@/redux/hooks'
import { useTheme } from '@itsrever/design-system'
import { computeColors } from '@/utils/colorPaletteGenerator'
import { SimplifiedLoginLayout } from '@/app/login/simplified-login-layout'
import { VerticalLoginLayout } from '@/app/login/vertical-login-layout'
import { HorizontalLoginLayout } from '@/app/login/horizontal-login-layout'

export const LoginPage = () => {
    const design = useAppSelector(
        (store) =>
            store.settingsApi.settings.response.branding?.layout_design_values
    )

    const theme = useTheme()

    computeColors(theme.colors.primary.main)

    const LoginLayout = () => {
        switch (design) {
            case 'VERTICAL':
                return <VerticalLoginLayout />
            case 'SIMPLIFIED':
                return <SimplifiedLoginLayout />
            default:
                return <HorizontalLoginLayout />
        }
    }

    return <LoginLayout />
}
